<template>
    <ModalBase id="campaign-selector" :minWidth="'80%'" :maxWidth="'80%'" :flex="false">
        <loader :loading="loading"></loader>
        <h1 class="ff-light title-modal" v-if="listCampaigns.length !== 0">{{ $t("menuHeader.selectCampaign") }}</h1>
        <div class="flexContainer logoContainer fd-r fw-w m-jc-sb">
            <div
                class="brandWrap flexContainer jc-c fd-c size1of4 pointer"
                v-if="listCampaigns.length !== 0"
                v-setUserInfo.currentCampaignId="0"
                @click="selectAllCampaign();"
            >
                <p class="brandLogo txtCenter ff-medium uppercase vCenter">{{ $t("catalogue.allCampaign") }}</p>
            </div>
            <div
                class="brandWrap flexContainer jc-c fd-c size1of4 pointer"
                v-for="camp in listCampaigns"
                :key="camp.id"
                v-setUserInfo.currentCampaign="camp.name"
                v-setUserInfo.campaignShort="camp.shortName"
                v-setUserInfo.currentCampaignId="camp.id"
                @click="selectCampaign(camp);"
            >
                <p class="brandLogo txtCenter ff-medium uppercase" :class="[currentCampaign.id == camp.id ? 'active' : '_notselectedCampaign', '']">
                    {{ camp.name }}
                </p>
            </div>
        </div>
    </ModalBase>
</template>

<script>
import ModalBase from "./ModalBase";
import { setUser } from "@/directives/setUser.js";
import { bus } from "@/main";
import { mapMutations, mapGetters } from "vuex";
import loader from "@/components/loader/loader";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import campaignService from "@/services/campaign";

export default {
    name: "ModalCampaign",
    data() {
        return {
            currentCampaign: { id: undefined },
            listCampaigns: []
        };
    },
    computed: {
        ...mapGetters("currentUser", ["currentUser"])
    },
    mixins: [TryLoadMixin],
    components: { ModalBase, loader },
    directives: {
        setUser
    },

    methods: {
        ...mapMutations("currentUser", ["SET_CURRENT_CAMPAIGN"]),
        selectAllCampaign() {
            this.currentCampaign = { id: 0, name: null, shortName: null };
            this.setCurrentCampaign();
        },
        selectCampaign(campaign) {
            this.currentCampaign = campaign;
            this.setCurrentCampaign();
        },
        setCurrentCampaign() {
            bus.$emit("closeModal", false);
            bus.$emit("resetOption", "null");
            this.SET_CURRENT_CAMPAIGN(this.currentCampaign);
            if (this.$route.name === "Planos") {
                this.$router.replace("/planos?campaign=" + this.currentCampaign.id);
            }
        },
        async getCampaigns() {
            this.listCampaigns = await this.tryLoad(() => campaignService.getAll());
            this.listCampaigns = this.listCampaigns.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
        }
    },
    created() {
        this.currentCampaign.id = this.currentUser.campaignId;
        this.getCampaigns();
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";
.brandLogo {
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
}
</style>
<style>
#campaign-selector .modalBody {
    margin-top: 100px;
}
</style>



// WEBPACK FOOTER //
// ModalCampaign.vue?3a0342ad